import { fExecuteAPI } from "../../Server/Apis";
import {
  inv11_AttributesINV11_GETROW,
  WMSStockTransfer_getStockEnquiry_GETROW,
  inv11_INV11_LoadDetail_GETROW,
  inv11_fINV11_fDisplay_GETROW,
} from "../../Server/ApiV2";
import { RoundingDigitRo, KernCAConfig } from "../../Redux/roStore";

import {
  fAlertToast,
  fcovertToNumber,
  fcheck_null_undefine_replace_empty,
  Get_TransItemStockUOM,
} from "../../Utility/Utilitys";

import {
  Set_StockAdjustment_HeadObject_Set,
  StockAdjustment_HeadObject_Party_Set,
} from "./SliceStockAdjustment";

import { vRdxUserInfo, StockAdjustmentRo } from "../../Redux/roStore";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

export const ErrorMsg = {
  A_VocTyp: "",
  A_VocNo: "",
  A_PostDt: "",
  A_RefNo: "",
  A_RefDt: "",
  A_Type: "",
  A_PayMode: "",
  UnloadingBay: "",
  A_Party: "",
  A_PartyName: "",
  A_Curr: "",
  A_ExRate: "",
  A_Loc: "",

  TaxType: "",
  offer: "",
  A_RefBy: "",
  A_RefByname: "",
  A_CrAc: "",
  A_CrAcName: "",
  A_DrAc: "",
  A_DrAcName: "",
  A_Rounding: "",
  A_DocStat: "",
  A_Taxable: "",
  xErrorMsg: "",

  CreditLimit: "",
  OsAmount: "",
  AvlAmt: "",
  TransferType: "",

  A_RefDocCd: "",
  A_RefDocName: "",
  A_RefDocType: "",

  A_FromLocBr: "",
  A_FromLocBrName1: "",
  A_FromLocBatch: "",
  A_FromLocName: "",
  A_FromLoc: "",
  A_FromLocTrn: "",
  A_ToLocBr: "",
  A_ToLocBrName1: "",
  A_ToLocBatch: "",
  A_ToLoc: "",
  A_ToLocTrn: "",
  A_ToLocName: "",
  A_Do: "",
  AdjustmentType: "",
};
export const ErrorMsgDetail = {
  B_Srno: "", // int
  B_Itmcd: "",
  B_ItmName: "",
  B_Qty: "", //Decimal
  B_Unit: "",
  B_UnitName: "",
  B_PackQty: "", //Decimal
  B_BaseQty: "", //Decimal
  B_RefDocTyp: "",
  B_RefDocTypName: "",
  B_RefDocNo: "",
  B_UnitCost: "",
  B_Value: "",
  Reason: "",
  Auto: "",
};
export const vHeaderSearchInit = {
  AnyData: "",
  Name: "",
  Code: "",
};

export const sTrnTyp = "INV11";

export const ItemSearchData = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

export const locatonSearchData = ["Any", "Code", "Name"];

export const sStatusArr = ["ENTER", "POST", "DELETE", "DRAFT", "CANCEL"];
//GCSearch

const GridDataColumnsLocationSearch = [
  { field: "id", headerName: "id", hide: true },
  { field: "UID", headerName: "Code" },
  { field: "Name1", headerName: "Name" },
];

const fKeyStockAdjustment = (event) => {
  const form = document.getElementById("WmsStockAdjustmentHead");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fKeyStockAdjustmentContent = (event) => {
  const form = document.getElementById("WmsStockAdjustmentContent");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fValidationHead_Client = (vRdxHead, setErrorMsg, sFooterObj) => {
  let iRes = true;

  if (
    vRdxHead.A_VocTyp === "" ||
    vRdxHead.A_VocTyp === null ||
    vRdxHead.A_VocTyp === undefined
  ) {
    fAlertToast("FAILED", "VocTyp should not be empty");
    setErrorMsg((obj) => ({
      ...obj,
      A_VocTyp: "VocTyp should not be empty",
    }));
    iRes = false;
  }

  if (
    vRdxHead.A_VocNo === "" ||
    vRdxHead.A_VocNo === null ||
    vRdxHead.A_VocNo === undefined
  ) {
    fAlertToast("FAILED", "VocNo should not be empty");
    setErrorMsg((obj) => ({ ...obj, A_VocNo: "VocNo should not be empty" }));
    iRes = false;
  }

  // default format so no need to check format
  if (
    vRdxHead.A_RefDt === "" ||
    vRdxHead.A_RefDt === null ||
    vRdxHead.A_RefDt === undefined
  ) {
    fAlertToast("FAILED", "Date should not be empty");
    setErrorMsg((obj) => ({
      ...obj,
      A_RefDt: "Date should not be empty",
    }));
    iRes = false;
  }

  if (
    vRdxHead.A_FromLoc === "" ||
    vRdxHead.A_FromLoc === null ||
    vRdxHead.A_FromLoc === undefined
  ) {
    fAlertToast("FAILED", "From location should not be Empty");
    setErrorMsg((obj) => ({
      ...obj,
      A_FromLoc: "From location should not be Empty",
    }));
    iRes = false;
  }

  if (
    vRdxHead.A_Do === "" ||
    vRdxHead.A_Do === null ||
    vRdxHead.A_Do === undefined
  ) {
    fAlertToast("FAILED", "DO should not be Empty");
    setErrorMsg((obj) => ({
      ...obj,
      A_Do: "DO should not be Empty",
    }));
    iRes = false;
  }

  return iRes;
};

export const UnitRateFlag = () => {
  const { DBKernObj } = KernCAConfig();
  const iShowField = DBKernObj.WMINV03_UNITRATE_VLDT?.Val === "N";
  if (iShowField) {
    return false;
  } else {
    return true;
  }
};

const fValidationDetail_Client = (
  vRdxHead,
  sBufferObj,
  setErrorMsgDetail,
  sDetailGridData
) => {
  let iRes = true;

  if (sBufferObj.B_Srno === "") {
    fAlertToast("FAILED", "Serial number should not be empty");
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Srno: "Serial number should not be empty",
    }));
    iRes = false;
  }

  if (sBufferObj.B_Itmcd === "") {
    fAlertToast("FAILED", "Item code should not be empty");
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Itmcd: "Item code should not be empty",
    }));
    iRes = false;
  }

  if (sBufferObj.B_ItmName === "") {
    fAlertToast("FAILED", "Item name should not be empty");
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmName: "Item name should not be empty",
    }));
    iRes = false;
  }

  if (sBufferObj.B_Qty === "") {
    fAlertToast("FAILED", "Qty should not be zero");
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Qty: "Qty should not be zero",
    }));
    iRes = false;
  }

  if (sBufferObj.Reason === "") {
    fAlertToast("FAILED", "Reason should not be empty");
    setErrorMsgDetail((obj) => ({
      ...obj,
      Reason: "Reason should not be empty",
    }));
    iRes = false;
  }

  if (sBufferObj.B_Unit === "") {
    fAlertToast("FAILED", "Select unit");
    setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
    iRes = false;
  } else if (
    sBufferObj.B_PackQty === "" ||
    Number(sBufferObj.B_PackQty) === 0
  ) {
    fAlertToast("FAILED", "Pack quantity should not be zero");
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Unit: "Pack quantity should not be zero",
    }));
    iRes = false;
  }

  return iRes;
};

//GCItemSearch
const GetItemSearch = async (
  xValue,
  xVendor,
  setGridSelectRowData,
  setGridSelectRowArr
) => {
  //openCustomer to call api on open modal if value in any data

  let sItemSearch = {
    v_AnyData: xValue,
    v_ItmCd: "",
    v_ItmName: "",
    v_Barcode: "",
    v_ModelSelectedValue: "",
    v_RefNo1: "",
    v_NameFc: "",
    v_CostPr: "",
    v_RSP: "",
    v_Catalogue: "",
    v_Br: "",
    v_RefNo3: "",
    v_Loc: "",
    v_Vendor: xVendor,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(sItemSearch);
  const vItemSearch = await fExecuteAPI("GRN_ITEMSEARCH_GETROW", FinalObj);
  if (vItemSearch.Status === 200) {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setGridSelectRowArr(vItemSearchArr);
    setGridSelectRowData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.Type.response.data.message
        ? vItemSearch.Type.response.data.message
        : "Error in ItemSearch"
    );
    return [];
  }
};

//API  UNIT_RATE_GETROW

const GetUnitRateArr = async (xItmCd, xUnitId, xLoc, xVocTyp) => {
  let vUnitRateObj = {
    ItmCd: xItmCd,
    UnitId: xUnitId,
    Loc: xLoc,
    Type: xVocTyp,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vUnitRateObj);

  const UnitRateInfo = await fExecuteAPI("WMINV11_UnitRate_GETROW", FinalObj);
  if (UnitRateInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitRateInfo.ResultSet.length > 0) {
      return UnitRateInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitRateInfo.Type.response.data.message
        ? UnitRateInfo.Type.response.data.message
        : "Error in UnitRateArr"
    );
    return [];
  }
};

//TODO FULLSEARCH ,UNITARR ,AND CALCULATION
const fItemCodeDependency = async (
  vItemSearchFull,
  vRdxWmsHead,
  sBufferObj,
  setBufferObj,
  setUnit
) => {
  if (vItemSearchFull.length > 0) {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
      B_Barcode: vItemSearchFull[0].BarCode,
      // B_TaxDept: vRdxGRNtax1arr?.UId,
      // B_TaxPerc: vRdxGRNtax1arr?.Perc,
    }));

    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    let iUnit = vItemSearchFull[0]?.DefUnit || "";

    if (!iUnit) {
      iUnit = vItemSearchFull[0]?.PurUOM || "";
    }

    let vItemUnitSet = currentUnitArr.find((obj) => {
      return obj.Unit === iUnit;
    });

    if (!vItemUnitSet) {
      iUnit = currentUnitArr[0]?.Unit || "";

      vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === iUnit;
      });
    }
    await Unit_Onchange_001(
      vItemUnitSet,
      vItemSearchFull[0].ItmCd,
      setBufferObj,
      sBufferObj,
      vRdxWmsHead
    );

    document.getElementsByName("B_Qty")[0]?.focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

export const Unit_Onchange_001 = async (
  xUnitObj = {},
  xItemCd = "",
  setBufferObj,
  sBufferObj,
  vRdxWmsHead
) => {
  if (!!xUnitObj) {
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: xUnitObj.Unit,
      B_UnitName: xUnitObj.Name1,
      B_PackQty: xUnitObj.PackQty,
    }));
  }

  let { B_BaseQty } = fStockAdjustmentCal(sBufferObj.B_Qty, xUnitObj.PackQty);
  setBufferObj((obj) => ({
    ...obj,
    B_BaseQty,
  }));

  let currentUnitRateArr = await GetUnitRateArr(
    xItemCd,
    sBufferObj.B_Unit,
    vRdxWmsHead?.A_FromLoc,
    "" // vRdxWmsHead?.A_RefDocTyp,
  );

  if (currentUnitRateArr.length > 0) {
    fCalUCostAndValue(
      sBufferObj.B_Qty,
      currentUnitRateArr[0].CostPr,
      setBufferObj
    );
  } else {
    fCalUCostAndValue(sBufferObj.B_Qty, 0, setBufferObj);
  }
};

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch.Type == "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};

const fLoad_Grid = async (
  xB_VocNo,
  xB_Srno,
  setDetailGridData,
  setFooterObj,
  xVocTyp,
  xRoundingValue
) => {
  const iSIDetail = await GetSIDetail(xB_VocNo, xB_Srno, xVocTyp);
  if (iSIDetail.length > 0) {
    let GridID = iSIDetail?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
    var F_NetValue = 0;

    for (let i = 0; i < iSIDetail?.length; i++) {
      F_NetValue += iSIDetail[i]?.B_NetAmt;
    }
    setFooterObj((obj) => ({
      ...obj,
      F_NetValue: F_NetValue.toFixed(xRoundingValue),
    }));
  } else {
    setDetailGridData([]);
    setFooterObj((obj) => ({
      ...obj,
      F_NetValue: (0).toFixed(xRoundingValue),
    }));
  }
};

//HEAD LOADING API
// Api

// Checkbox_Rights_GETROW
const GetCheckboxUserRights = async (dispatch) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const vCheckBoxRightsObj = {
    usercd: vRdxUserInfoObj.UserID,
    usergrp: vRdxUserInfoObj.UserGroupCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vCheckBoxRightsObj);
  const vCheckBoxRights = await fExecuteAPI(
    "Checkbox_User_Rights_GETROW",
    FinalObj
  );
  if (vCheckBoxRights?.Type?.toUpperCase() === "SUCCESS") {
    return vCheckBoxRights?.ResultSet;
  } else {
    fAlertToast(
      "FAILED",
      vCheckBoxRights?.response?.data?.message
        ? vCheckBoxRights?.response?.data?.message
        : "Error in CheckBoxRights"
    );
    return [];
  }
};

//SALESMAN_GETROW
const GetSalesman = async (dispatch) => {
  const iSalesman = await fExecuteAPI("SALESMAN_GETROW");
  if (iSalesman?.Type?.toUpperCase() === "SUCCESS") {
    return iSalesman.ResultSet.length > 0 ? iSalesman.ResultSet : [];
  } else {
    fAlertToast(
      "FAILED",
      iSalesman.response.data.Status
        ? iSalesman.response.data.Status
        : "Error in Currency"
    );
    return [];
  }
};

//API GRN_LOCATIONSEARCH_GETROW
const GetLocation = async (
  xAnyData,
  xCode,
  xName,
  UserID,
  setHeaderSearchResultArr,
  setHeaderSearchResultData
) => {
  let vHeaderSearchObj = {
    v_AnyData: xAnyData,
    v_Cd: xCode,
    v_Distri: "Y",
    v_Name: xName,
    v_UserCd: UserID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vHeaderSearchObj);

  const vHeaderSearch = await fExecuteAPI(
    "GRN_LOCATIONSEARCH_GETROW",
    FinalObj
  );
  if (vHeaderSearch.Status === 200) {
    let GridID = vHeaderSearch.ResultSet?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setHeaderSearchResultArr(GridID);
    setHeaderSearchResultData(GridID);
    return GridID;
  } else {
    fAlertToast(
      "FAILED",
      vHeaderSearch.response.data.Status
        ? vHeaderSearch.response.data.Status
        : "Error in loading SrcDoc"
    );
    return [];
  }
};

//API Unit GETITEMUNITSINBOUND_GETROW
const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    ItemCd: xItemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI("WMINV10_itemUnit_GETROW", FinalObj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.response.data.Status
        ? UnitInfo.response.data.Status
        : "Error in UnitArr"
    );
    return [];
  }
};

//API  ITEM_LINE_GETROW
const GetItemLineArr = async (xItemCode, xLoc, xParty, setItemLine) => {
  let vItemLineObj = {
    v_ItemCd: xItemCode,
    v_Loc: xLoc,
    v_Vendor: xParty,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemLineObj);

  const ItemLineInfo = await fExecuteAPI("ITEM_LINE_GETROW", FinalObj);
  if (ItemLineInfo.Status === 200) {
    if (ItemLineInfo.ResultSet.length > 0) {
      setItemLine(ItemLineInfo.ResultSet);
      return ItemLineInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      ItemLineInfo.Type.response.data.message
        ? ItemLineInfo.Type.response.data.message
        : "Error in ItemLineArr"
    );
    return [];
  }
};

//API
const GetItemFullSearchArr = async (xItemName, xLoc) => {
  // let vItemFullSearchDataObj = {
  //   v_AnyData: xItemName,
  //   v_TransType: "F",
  //   v_Report: "Y",
  // };
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI(
    // "ITEM_SEARCHFULL_GETROW",
    "SEARCHEXACTITEM_GETROW",
    FinalObj
  );
  //status code "" so Success is checked
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull.Type.response.data.message
        ? vItemSearchFull.Type.response.data.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

//API GETSIDETAILS_GETROW
const GetSIDetail = async (xB_VocNo, xB_Srno, xVocTyp) => {
  let iSIDetailObj = {
    v_VocTyp: !!xVocTyp ? xVocTyp : "",
    v_VocNo: !!xB_VocNo ? xB_VocNo : "",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const resp = await inv11_INV11_LoadDetail_GETROW(FinalObj);

  if (resp?.status === 200) {
    if (resp.data.ResultSet?.length > 0) {
      return resp?.data?.ResultSet;
    } else {
      return [];
    }
  }
};

//API GETSIHEAD_GETROW to gethead
const fDisplay = async (xA_VocTyp, A_VocNo, dispatch, fNewDetail) => {
  const { HeadObject } = StockAdjustmentRo();
  let vSIHeadObj = {
    v_TrnTyp: sTrnTyp,
    v_A_VocTyp: xA_VocTyp,
    v_A_VocNo: A_VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSIHeadObj);
  const resp = await inv11_fINV11_fDisplay_GETROW(FinalObj);
  if (resp?.status === 200) {
    dispatch(
      Set_StockAdjustment_HeadObject_Set({
        ...HeadObject,
        A_VocTyp: resp?.data?.ResultSet[0].A_VocTyp,
        A_VocTypName: resp?.data?.ResultSet[0].VocName,
        A_VocNo: resp?.data?.ResultSet[0].A_VocNo,
        A_PostDt: resp?.data?.ResultSet[0].A_VocDt,
        A_RefDt: resp?.data?.ResultSet[0].A_VocDt,
        A_Party: resp?.data?.ResultSet[0].A_Party,
        A_PartyName: resp?.data?.ResultSet[0].PartyName,

        A_Narr: resp?.data?.ResultSet[0].A_Narr,
        A_DocStat: resp?.data?.ResultSet[0].A_DocStat,

        A_FromLoc: resp?.data?.ResultSet[0].A_Loc,
        A_FromLocName: resp?.data?.ResultSet[0].LocName,

        A_FromLocBr: resp?.data?.ResultSet[0].A_Br,
        A_FromLocBatch: resp?.data?.ResultSet[0].A_CUSTFIELD8,
        A_Do: !!resp?.data?.ResultSet[0].A_CUSTFIELD9
          ? resp?.data?.ResultSet[0].A_CUSTFIELD9
          : "N",
        AdjustmentType: resp?.data?.ResultSet[0]?.A_StkAdjTyp,
      })
    );
    // fLocationDependency(vSIHead.ResultSet[0].A_LocTo, dispatch);

    fNewDetail(
      resp?.data?.ResultSet[0].A_VocNo,
      resp?.data?.ResultSet[0].A_VocTyp
    );
  }
};

const Get_ToggleDropDown_Load = async (
  xData,
  xType,
  xAcTyp,
  xExact,
  dispatch
) => {
  const { HeadObject } = StockAdjustmentRo();
  let vLoaded_Cost_FreightObj = {
    Data: xData,
    Type: xType,
    Loc: HeadObject.A_FromLoc,
    AcTyp: xAcTyp,
    Exact: xExact,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "AccountTransSearch_GETROW",
    FinalObj
  );
  if (vLandedCostDropdownSearch?.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};

//API SALESGROUP
const GetSalesGroups = async (xA_Loc) => {
  const vSalesGroups = await fExecuteAPI("SALESGROUPS_GETROW", xA_Loc);
  if (vSalesGroups.Type == "SUCCESS") {
    return vSalesGroups.ResultSet;
  } else {
    fAlertToast("FAILED", vSalesGroups.Message);
    return [];
  }
};

var vheaderArrow = 0;
const fRightClick = (e) => {
  vheaderArrow !== 1 ? (vheaderArrow = vheaderArrow + 1) : (vheaderArrow = 1);

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

const fLeftClick = (e) => {
  vheaderArrow !== 0 ? (vheaderArrow = vheaderArrow - 1) : (vheaderArrow = 0);
  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

const GetParty = async (dispatch, xLoc) => {
  const vPartyObj = {
    Loc: xLoc,
  };
  const vParty = await fExecuteAPI("WMINV10_Party_GETROW", vPartyObj);
  if (vParty?.Type?.toUpperCase() === "SUCCESS") {
    return vParty?.ResultSet;
  } else {
    fAlertToast(
      "FAILED",
      vParty.response.data.message
        ? vParty.response.data.message
        : "Error in Party"
    );
    return [];
  }
};
const fLocationDependency = async (Locparty, dispatch) => {
  let iParty = {
    AcCd: "",
    Name2: "",
    OSAmt: 0,
    PDCAmt: "",
    CrLimit: 0,
    Blocked: "",
  };

  let vParty = await GetParty(dispatch, Locparty);
  if (vParty.length > 0) {
    iParty = vParty[0];
  }
  dispatch(
    StockAdjustment_HeadObject_Party_Set({
      A_Party: iParty.AcCd,
      A_PartyName: iParty.Name2,
      CreditLimit: iParty.CrLimit,
      OsAmount: iParty.OSAmt,
      AvlAmt: Number(iParty?.CrLimit) - Number(iParty?.OSAmt),
    })
  );
};

//calculation
const fStockAdjustmentCal = (xQty, xPackQty) => {
  const { roundingDigit } = RoundingDigitRo();
  const B_Qty = fcovertToNumber(xQty);
  const B_PackQty = fcovertToNumber(xPackQty);

  let B_BaseQty = B_PackQty * B_Qty;

  return {
    B_BaseQty: B_BaseQty.toFixed(roundingDigit), //Decimal
  };
};
export const fCalUCostAndValue = (xQty, CostPr, setBufferObj) => {
  const { roundingDigit } = RoundingDigitRo();
  const iCostPr = fcovertToNumber(CostPr);
  const iB_Qty = fcovertToNumber(xQty);
  setBufferObj((obj) => ({
    ...obj,
    B_UnitCost: iCostPr.toFixed(roundingDigit),
    B_Value: (iCostPr * iB_Qty).toFixed(roundingDigit),
  }));
};

export const GetAttributes = async (
  setObjectRights,
  setUser_Doc_Arr,
  setLocationArr,
  setDocLoading,
  setFromLocation,
  setReason,
  setLocationSearchArr,
  setAdjustmentType
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    userCd: vRdxUserInfoObj.UserID,
    userGrp: vRdxUserInfoObj.UserGroupCode,
  };
  const iAttributes = await inv11_AttributesINV11_GETROW(vObj);
  if (iAttributes?.status === 200) {
    setUser_Doc_Arr(iAttributes?.data?.ResultSet?.UserDoc);
    setObjectRights(iAttributes?.data?.ResultSet?.Rights);
    setDocLoading(iAttributes?.data?.ResultSet?.Voucher);
    setLocationArr(iAttributes?.data?.ResultSet?.Location);
    setLocationSearchArr([
      ...iAttributes?.data?.ResultSet?.Location,
      {
        UId: "All",
        Name1: "All",
        BatchCtrl: " ",
        Br: " ",
        BrName: " ",
        MBCDSearch: "",
      },
    ]);
    setFromLocation(iAttributes?.data?.ResultSet?.Location);
    setReason(iAttributes?.data?.ResultSet?.Reason);
    setAdjustmentType(iAttributes?.data?.ResultSet?.AdjustmentType);
    return iAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};
export const GetHeadGrid = async (
  setHeadGridRow,
  setHeadGridShow,
  itemcode = ""
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = StockAdjustmentRo();
  var vObj = {
    itmCd: itemcode,
    userCd: vRdxUserInfoObj.UserID,
    loc: HeadObject.A_FromLoc,
  };
  const iAttributes = await WMSStockTransfer_getStockEnquiry_GETROW(vObj);
  if (iAttributes?.status === 200 && iAttributes?.data?.ResultSet.length > 0) {
    setHeadGridRow(iAttributes?.data?.ResultSet);
    setHeadGridShow(true);
  } else {
    return [];
  }
};
export const getTransItemStockUOM = async (
  setTransItemStockObj,
  xB_Itmcd,
  xB_Unit,
  xLoc
) => {
  let ApiObj = await Get_TransItemStockUOM(xB_Itmcd, xB_Unit, xLoc);
  if (ApiObj?.length > 0) {
    setTransItemStockObj({
      RPStock: ApiObj[0]?.RPStock,
      MSP: ApiObj[0].MSP,
      CostPr: ApiObj[0].CostPr,
      LPRate: ApiObj[0].LPRate,
    });
  }
};
const Get_GCToggleSearch_Customer_Api = async (
  xData,
  xType,
  xA_Loc,
  setCustSearchGridData
) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  const vItemSearch = await fExecuteAPI("PARTYSEARCH001_GETROW", vSeatchVendor);
  if (vItemSearch?.Type?.toUpperCase() == "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setCustSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch?.response?.data?.message ||
        vItemSearch?.message ||
        vItemSearch.response.data.Status ||
        "Error in DocLoading"
    );
  }
};

export {
  Get_GCToggleSearch_Customer_Api,
  fRightClick,
  fLeftClick,
  fKeyStockAdjustment,
  fKeyStockAdjustmentContent,
  GridDataColumnsLocationSearch,
  // Api
  GetCheckboxUserRights,
  GetSalesman,
  GetLocation,
  GetUnitArr,
  GetItemLineArr,
  GetItemFullSearchArr,
  GetItemSearch,
  fItemCodeDependency,
  GetSearchItem,
  GetSalesGroups,
  GetUnitRateArr,
  //save
  fValidationHead_Client,
  fValidationDetail_Client,
  fLoad_Grid,
  fDisplay,

  //reverse
  //Head functions
  fLocationDependency,
  GetParty,

  //src doc
  Get_ToggleDropDown_Load,
  fStockAdjustmentCal,

  //Approve
};
